





















import {
	Component,
	Prop,
	Vue,
	Inject,
	Watch,
} from 'vue-property-decorator';
import { ClassType } from 'class-transformer/ClassTransformer';
import { CrudService } from '@/data/services/crud.service';

@Component
export default class EntitySelect extends Vue {
	@Prop() value?: string | number;

	@Prop() entityClass!: ClassType<any>;
	@Prop() entityName!: string;
	@Prop() entityValue!: string;
	@Prop() entityLabel!: string;
	@Prop() placeholder?: string;
	@Prop({ default: false }) emptyOption?: boolean;
	@Prop({ default: true }) expanded?: boolean;
	@Prop({ default: false }) required?: boolean;
	@Prop({ default: false }) disabled!: boolean;

	@Inject('CrudService') crudService!: CrudService<any>;

	newValue: string | number | null = null;
	items: any[] = [];
	loading: boolean = false;

	@Watch('value', { immediate: true })
	onValueChange(value: string | number) {
		this.newValue = value;
	}

	get computedValue() {
		return this.newValue;
	}

	set computedValue(value: string | number | null) {
		this.newValue = value;
		this.$emit('input', value);
	}

	created() {
		this.loadData();
	}

	loadData() {
		this.loading = true;
		this.crudService
			.getAll(
				this.entityClass,
				this.entityName,
			)
			.then((result) => {
				this.items = result;
			})
			.finally(() => (this.loading = false));
	}

}
